import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

export const TimeEntriesContext = createContext({
  screen: null,
  screenId: null
});

export function TimeEntriesProvider({ screen, screenId, children }) {
  const contextValue = useMemo(() => {
    return {
      screen,
      screenId
    };
  }, [screen, screenId]);

  return <TimeEntriesContext.Provider value={contextValue}>{children}</TimeEntriesContext.Provider>;
}

TimeEntriesProvider.propTypes = {
  screen: PropTypes.string,
  screenId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node
};

TimeEntriesProvider.defaultProps = {
  screen: null,
  screenId: null,
  children: null
};
